module.exports = __webpack_public_path__ + "static/img/b104.f1238d1c.png";